import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setCurrentTask } from 'qwc2/actions/task';
import CoordinatesUtils from 'qwc2/utils/CoordinatesUtils';
import proj4 from 'proj4';

class StreetViewPlugin extends React.Component {
    static propTypes = {
        currentTask: PropTypes.string,
        mapClick: PropTypes.object,
        mapCrs: PropTypes.string,
        dispatch: PropTypes.func.isRequired
    };

    // 1. Add local state to control the UI banner
    state = {
        showError: false
    };

    componentDidUpdate(prevProps) {
        if (this.props.currentTask === 'StreetView') {
            if (this.props.mapClick && this.props.mapClick !== prevProps.mapClick) {
                const coords = this.props.mapClick.coordinate;
                let lon, lat;

                // ISOLATED MATH: LUREF to WGS84 with correct 7-parameter Helmert
                if (this.props.mapCrs === 'EPSG:2169') {
                    const lurefPrecise = '+proj=tmerc +lat_0=49.83333333333334 +lon_0=6.166666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-193.0,13.7,-39.3,-0.41,-2.933,2.688,0.43 +units=m +no_defs';
                    const wgs84 = '+proj=longlat +datum=WGS84 +no_defs';
                    
                    const preciseCoords = proj4(lurefPrecise, wgs84, coords);
                    lon = preciseCoords[0];
                    lat = preciseCoords[1];
                } 
                // FALLBACK: For any other map projections
                else {
                    const wgs84Coords = CoordinatesUtils.reproject(coords, this.props.mapCrs, 'EPSG:4326');
                    if (!wgs84Coords) {
                        console.error("StreetView Plugin: Reprojection failed!");
                        return;
                    }
                    lon = wgs84Coords[0];
                    lat = wgs84Coords[1];
                }
                
                // 2. Trigger the API check instead of opening the URL directly
                this.checkCoverageAndOpen(lat, lon);
            }
        }
    }

    // 3. The API Function
    checkCoverageAndOpen = async (lat, lon) => {
        // Look ma, no API keys! 
        // We are just calling our own server's route now.
        const backendUrl = `/api/streetview-check?lat=${lat}&lon=${lon}`;

        try {
            const response = await fetch(backendUrl);
            const data = await response.json();

            // The rest of the logic remains exactly the same!
            if (data.status === 'OK') {
                const snappedLat = data.location.lat;
                const snappedLon = data.location.lng;
                
                const url = `https://www.google.com/maps?layer=c&cbll=${snappedLat},${snappedLon}`;
                window.open(url, '_blank');
                
                this.props.dispatch(setCurrentTask(null));
            } else {
                // ZERO_RESULTS (No coverage found)
                this.setState({ showError: true });
                
                setTimeout(() => {
                    this.setState({ showError: false });
                }, 3000);
            }
        } catch (error) {
            console.error("Failed to reach the backend server:", error);
        }
    };

    render() {
        if (this.props.currentTask === 'StreetView') {
            return (
                <div style={{
                    position: 'absolute', top: '60px', left: '50%', transform: 'translateX(-50%)',
                    background: this.state.showError ? '#D32F2F' : '#0078A8', // Red for error, Blue for default
                    color: 'white', padding: '10px 20px', zIndex: 99999, 
                    borderRadius: '4px', boxShadow: '0 2px 10px rgba(0,0,0,0.5)', 
                    display: 'flex', alignItems: 'center', gap: '15px',
                    transition: 'background 0.3s ease' // Smooth color fade
                }}>
                    <span>
                        <strong>Street View:</strong> {this.state.showError ? "No coverage found nearby." : "Click anywhere on the map to open"}
                    </span>
                    <button onClick={() => this.props.dispatch(setCurrentTask(null))} 
                            style={{ cursor: 'pointer', background: 'white', color: 'black', border: 'none', padding: '5px 10px', borderRadius: '3px' }}>
                        Cancel
                    </button>
                </div>
            );
        }
        return null;
    }
}

const mapStateToProps = state => ({
    currentTask: state.task ? state.task.id : null,
    mapClick: state.map.click || null,
    mapCrs: state.map.projection || 'EPSG:3857'
});

export default connect(mapStateToProps)(StreetViewPlugin);